<bp-create-account-form
	class="h-100"
	[email]="(identityFacade.incompleteIdentity$ | async)?.email"
	[pending]="introFacade.pending$ | async"
	[error]="introFacade.error$ | async"
	(submitted)="identityFacade.createAccount($event)"
	(login)="introFacade.gotoLoginPage()"
>
</bp-create-account-form>
